// Cockpit IA: departments and tools.
//
// The canonical catalog (types, COCKPIT_DEPARTMENTS, helpers, plus the
// server-side VALID_TOOL_SLUGS allowlist) lives in cockpit/shared/catalog.ts
// so the UI and the pins Lambda import the same data and cannot drift.
// Add or remove a tool there, in one place.

export {
  COCKPIT_DEPARTMENTS,
  VALID_TOOL_SLUGS,
  findDepartment,
  findTool,
  isLaunched,
  isValidToolSlug,
  totals,
  type Coverage,
  type Department,
  type Tool,
  type ToolSlug,
  type ToolStatus,
} from '../../../shared/catalog';

// UI-only concerns below. The server doesn't care about these.

// Pinned tools shown at the top of the sidebar when the user hasn't pinned
// anything yet. Per-user pins live in the cockpit_user_pins table and override
// this default once a user has interacted with the pin UI.
export type PinnedTool = {
  deptId: string;
  toolId: string;
  label: string;
};

export const PINNED_TOOLS: PinnedTool[] = [
  { deptId: 'commerce', toolId: 'orders', label: 'Orders' },
];

// Default-open department sections in the sidebar.
// 'retail' fixed to 'stores' (2026-08-09): the department id has been 'stores'
// since the Retail + Stores merge (2026-07-06); 'retail' never matched any
// department id and silently did nothing.
export const DEFAULT_OPEN_DEPTS: string[] = ['commerce', 'crm', 'it', 'stores'];
